export enum PaymentType {
    Cash = 'CASH',
    BankTransfer = 'BankTransfer',
    ZaloPay = 'ZaloPay',
    Payon = 'Payon',
    Momo = 'Momo',
    Vnpay = 'Vnpay',
    PosappCard = 'PosappCard',
    Mpos = 'Mpos_new',
    ACB = 'ACB',
    Uni = 'Uni',
    Bidv = 'Bidv',
    Eximbank = 'Eximbank'
}
